<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section v-menu-permission="'list'" class="app-content">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" aria-labelledby="headingOne" class="collapse show"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter ref="emListFilter"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                           :entity="modelName"
                                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesQualityDocumentResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" aria-labelledby="headingTwo" class="collapse show"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table ref="emTable"
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      :entity="modelName" :inlineActionsDisabled="prop_inline!=='1'" exportDisabled
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow">

                                <template #left-header>
                                    <b-button-group>
                                        <batch-upload-attachment-with-store
                                            :doQuery="doQuery"
                                            :modelName="modelName"
                                            :voName=$_emCustomVuexMixin_vo
                                            attachmentFieldName="qualityFileIds"
                                            title="批量上传质量文件"
                                        />
                                        <em-button
                                            :disabled="notSelected"
                                            custom-icon="fa fa-fw fa-lg fa-download"
                                            custom-label="批量下载"
                                            type="export"
                                            v-bind:class="'btn btn-outline-primary btn-sm'"
                                            @click="downloadAllWithParamName('qualityFileIds')"
                                        ></em-button>
                                        <!--                                    <mini-button :disable="$_notChecked" :loading="downloadLoading"-->
                                        <!--                                                 @btnClick="$_downloadBomDrawing">-->
                                        <!--                                        <i class="fa-solid fa-file-zipper"></i>-->
                                        <!--                                        技术文件下载-->
                                        <!--                                    </mini-button>-->
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
// Author Liu Cui Cui
// Date 2024-12-31 13:43:55

import emCommonListMixin from "@/mixin/em/common/list";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import BatchUploadAttachmentWithStore from "@/components/common/attachment/BatchUploadAttachmentWithStore.vue";
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";

export default {
    name: "sithMesQualityDocumentListView",
    components: {MiniButton, BatchUploadAttachmentWithStore},
    mixins: [emCommonListMixin, emCustomVuexMixin, emTableCheckedMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        entityBaseUrl() {
            return `${this.$_emApiMixin_entityBaseApi('sithMesQualityDocument')}/`
        },
        headers() {
            let headers = {}
            let jwt = localStorage['em_sso_token']
            if (jwt != null) {
                headers['Authorization'] = jwt;
            }
            return headers;
        },
        attachmentQueryApi() {
            return `${process.env.VUE_APP_SITHMES_QUALITY_URL}/${this.modelName}/getAttachmentList`;
        },
        $_rowMaterialKey() {
            return 'materialNumber';
        }
    },
    methods: {
        doQuery() {
            this.$refs["emListFilter"].doQuery();
        },
        downloadAllWithParamName(paramName, fileName) {
            let attachmentIds = this.checkedRows.filter(f => this.hasCode(f[paramName])).map(o => o[paramName]).join(",");
            this.downloadAllAttachment(attachmentIds, fileName);
        },
    }
};
</script>